import { render, staticRenderFns } from "./Screenshots.vue?vue&type=template&id=4e9362a8"
import script from "./Screenshots.vue?vue&type=script&lang=js"
export * from "./Screenshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports